import React, { Component } from 'react';
import { StripeProvider, Elements, injectStripe, CardElement } from 'react-stripe-elements';

let stripeLoading;
export class PaymentSources extends Component {
    constructor(props) {
        super(props);
        this.state = {showForm:false, showMessage:false}

        // Fixme: this could be moved outside this element to decrease latency
        if (!stripeLoading) {
            stripeLoading = loadStripe()
                .catch(() => loadStripe()) // Retry
                .then(() => {
                    this.setState({stripeLoaded:true});
                })
                .catch(() => {
                    this.showMessage("Network Error");
                    stripeLoading = undefined; // Give up, allow retry next time?
                });
        }
    }

    showMessage(msg) {
        this.setState({showMessage:msg, showForm:false})
        setTimeout(() => this.setState({showMessage:false}), 2000);
    }

    async handleSubChanged() {
        await this.props.onSubChanged();
        this.showMessage("Card set!");
        this.setState({showForm:false})
    }

    render() {
        const src = this.props.sources;
        const app = this.props.app;

        if (!src || !src.sources || !src.sources.length) {
            return <p>No payment information</p>;
        }

        const stripeLoaded = this.state.stripeLoaded;
        if (this.state.showForm && stripeLoaded) {
            return <div><h4>Update payment method <button type="button" alt="cancel" title="cancel" onClick={() => this.handleSubChanged()}>&times;</button></h4>
                <PaymentUpdateForm app={app} onSubChanged={() => this.handleSubChanged()} />
            </div>;
        }

        const sources = src.sources.map((s, i) => {
            return <p key={i}>{paymentSourceLong(s)}</p>;
        });
        return <div><h4>Payment method</h4>{sources} {this.state.showForm ? '(loading…)' :
            (this.state.showMessage ? this.state.showMessage : <button type="button" onClick={() => {this.setState({showForm:true});return false;}}>Change</button>)}</div>
    }
}

class PaymentUpdateForm extends Component {
    render() {
        return <StripeProvider apiKey={this.props.app.stripePublicKey}>
            <Elements>
                <PaymentUpdateInner app={this.props.app} onSubChanged={this.props.onSubChanged} />
            </Elements>
        </StripeProvider>;
    }
}

const PaymentUpdateInner = injectStripe(class _PaymentUpdateInner extends Component {
    constructor(props) {
        super(props);
        this.state = {error:null}
    }

    async handleSubmit(e) {
        e.preventDefault();
        try {
            this.setState({busy:true});
            const payload = await this.props.stripe.createToken()
            if (payload.error && payload.error.message) {
                this.setState({error:payload.error});
            } else {
                await this.props.app.setPaymentMethod(payload);
                await this.props.onSubChanged();
            }
        } catch(err) {
            this.setState({error:{
                message:`Error while setting the payment method (${err.message})`, type:"internal",
            }});
        } finally {
            this.setState({busy:false});
        }
        return false;
    }

    render() {
        return <form className="stripe-inline-form" onSubmit={e => this.handleSubmit(e)}>
            <label>
                {this.state.error ? <strong className={this.state.error.type}>{this.state.error.message}</strong> : 'Card details:'}
                <div className="card-element"><CardElement onChange={() => this.setState({error:null})} /></div>
            </label>
            {this.state.busy ? 'Setting…' : <input type="submit" value="Set card" />}
        </form>;
    }
})

function loadStripe() {
    return new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.onerror = reject;
        s.onload = resolve;
        setTimeout(reject, 7100);
        s.src = "https://js.stripe.com/v3/";
        document.documentElement.appendChild(s);
    });
}

function capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
}

export function paymentSourceShort(source) {
    return `${source.brand || source.object} …${source.last4 || source.dynamic_last4 || source.funding}`
}

export function paymentSourceLong(source) {
    return `${capitalize(source.funding || '')} ${source.object}: ${source.brand || ''} …${source.last4 || source.dynamic_last4}`
}



// WEBPACK FOOTER //
// ./src/ui/PaymentSources.jsx